<template>
	<div id="video-controls"  v-if="video.isLoaded">
		<i id="btn-play-pause-video" class="material-icons" @click="playPause">{{ video.playing ? "pause_circle_outline" : "play_circle_outline" }}</i>
		<i id="btn-loop-video" class="material-icons" :class="{active: video.loop}" @click="loop">loop</i>
		<!-- <span id="video-duration">{{ video.currentTime }} / {{ video.duration }}</span> -->
	</div>
</template>
<script>
import {mapState} from "vuex";

export default {
	computed: {
		...mapState("UI", ["video"]),
	},

	methods: {
		playPause() {
			let video = document.querySelector("#video");
			if (video.paused || video.ended) {
				video.play();
			} else {
				video.pause();
			}

			this.$store.dispatch("UI/setVideoPlaying");
		},
		loop() {
			let video = document.querySelector("#video");
			video.loop = !video.loop;
			this.$store.dispatch("UI/setVideoLoop");
		},
	},
};
</script>
<style lang="scss">
#video-controls {
	position: absolute;
	bottom: -25px;
	left: 0;

	i {
		cursor: pointer;
		font-size: 18px;
		&:first-of-type {
			margin-right: 14px;
		}
		&.active {
			color: var(--primary);
		}
	}
}
</style>
